import styled from 'styled-components';
import {Color} from '../../tokens/colors';
import {ServiceItem} from '../service-item/service-item';
import {Status, StatusCode} from '../status/status-order';

const StyledTable = styled.table`
    position: relative;
    display: block;
    padding: 0 24px 14px 52px;
    font-weight: 500;
    font-size: 13px;
    line-height: 1.2;
    color: ${Color.BLACK};
    border: none;
    border-collapse: collapse;

    th,
    td {
        padding: 0 200px 25px 0;
    }

    th:last-child,
    td:last-child {
        display: flex;
        justify-content: center;
    }

    th:first-child,
    td:first-child {
        max-width: 250px;
    }

    tbody > tr:last-child {
        td {
            padding-bottom: 0;
        }
    }

    th {
        padding-bottom: 20px;
        font-weight: 500;
        font-size: 12px;
        color: ${Color.TEXT_GRAY};
    }

    @media (max-width: 767px) {
        display: block;
        width: 100%;
        margin-top: 18px;
        margin-bottom: 10px;
        padding: 0;

        thead tr th {
            padding-left: 20px;

            &:not(:first-child) .status-code {
                display: none;
            }
        }

        tbody {
            display: block;

            tr {
                position: relative;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-left: 15px;
                padding-right: 15px;

                td:first-child div {
                    left: 20px;
                    bottom: unset;
                }
            }

            tr:not(:last-child) {
                margin-bottom: 18px;
                padding-bottom: 4px;
                border-bottom: 1px solid ${Color.BLOCK_GRAY};
            }

            tr:last-child {
                td {
                    padding-bottom: 14px;
                }
            }

            td {
                display: block;
                padding: 0 0 10px 0;
                margin-right: 19px;
            }
        }
    }
`;

const StyledStatusContainer = styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    text-align: center;
    gap: 24px;
    top: -50px;

    @media (max-width: 767px) {
        top: 0;
        right: 33px;
    }
`;

const ServicesTable = ({services, taskStatusCode, taskStatusText}) => {
    return (
        services.length > 0 && (
            <StyledTable>
                <thead>
                    <tr>
                        <th>Услуга</th>
                        <th></th>
                        <th>
                            <StyledStatusContainer>
                                <Status code={StatusCode[taskStatusCode]} className="status-code" isUppercase={true}>
                                    {taskStatusText}
                                </Status>
                                Статус
                            </StyledStatusContainer>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {services.map((service) => {
                        return <ServiceItem key={service.name} service={service} />;
                    })}
                </tbody>
            </StyledTable>
        )
    );
};

export {ServicesTable};
